import src from "IMAGE";
export default { src, width: 28, height: 28, blurWidth: 0, blurHeight: 0};
